import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { filter, map, take } from 'rxjs';

export const canMatchProfileComplete: CanMatchFn = (
  _: Route,
  __: UrlSegment[],
) => {
  return inject(AuthService).profileComplete$.pipe(
    filter((complete) => complete !== undefined),
    map((complete) => !!complete),
    take(1),
  );
};
